import React from "react";
import NumberFormat from "react-number-format";
import { FormGroup, Input, Label, UncontrolledTooltip } from "reactstrap";
import { isBiro } from "../../../utils/helper";

const FormField = ({ label, description, type, value, onChange }) => {
  const radios = [0, 1, 2, 3];
  return (
    <div className="row mb-3">
      <div className="col-md-5 d-flex align-items-center">
        <Label>
          {label}
          <sup
            className="badge cursor-pointer ml-1"
            style={{
              backgroundColor: "#eaeaea",
              borderRadius: "50%",
              fontSize: 8.5,
              display: "inline-block",
            }}
            id={label.split(" ").join("")}
            href="#"
          >
            ?
          </sup>
        </Label>
      </div>
      <UncontrolledTooltip placement="right" target={label.split(" ").join("")}>
        {description}
      </UncontrolledTooltip>
      <div className="col-md-7">
        {type === "radio" ? (
          radios.map((radio) => (
            <FormGroup check className="d-inline mr-2" onClick={() => onChange(radio)}>
              <Label check>
                <Input type="radio" name={label} value={value} checked={value === radio} /> {radio}
              </Label>
            </FormGroup>
          ))
        ) : (
          <NumberFormat
            className="form-control text-right"
            value={value}
            onValueChange={onChange}
            thousandSeparator={true}
            // disabled={isBiro() ? true : false}
            // prefix="Rp. "
          />
        )}
      </div>
    </div>
  );
};

export default FormField;
